import PropTypes from 'prop-types';
import Image from 'next/image';
import { Box, Grid, List, ListItem, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import CustomContainer from 'components/Shared/CustomContainer';

import { techJourneyContent as mock, IconImage } from 'mocks/techVertical';

import cloudinaryLoader from 'utils/loaderUtils';

TechJourney.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    paragraphs: PropTypes.arrayOf(PropTypes.string).isRequired,
    list: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
      })
    ).isRequired,
  }),
};

TechJourney.defaultProps = {
  content: mock,
};

export default function TechJourney({ content }) {
  const theme = useTheme();
  const mobileBreakpoint = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box component="section" bgcolor="background.secondary.main">
      <CustomContainer>
        <Grid
          container
          direction={{ xs: 'column', md: 'row' }}
          alignItems="flex-start"
          spacing={{ xs: 0, md: 4 }}
        >
          <Grid item xs={12}>
            <Box maxWidth={984} mx="auto" textAlign="center">
              <Typography
                fontWeight={700}
                mb={2}
                mx="auto"
                variant={mobileBreakpoint ? 'h6' : 'h4'}
              >
                {content?.title}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={6} width={{ xs: '100%', md: 'auto' }}>
            {content?.paragraphs.map((paragraph, index) => (
              <Typography variant="body1" mb={2} key={`paragraph-${index}`}>
                {paragraph}
              </Typography>
            ))}

            <Box position="relative" height={268} mb={{ xs: 4, sm: 0 }}>
              <Image
                alt="Teoria, Pratica e imersão"
                fill
                loader={cloudinaryLoader}
                sizes="(max-width: 768px) 100vw, (max-width: 1280px) 50vw"
                src="/Others/Home/jornada-fp_fv8oua"
                style={{ objectFit: 'contain' }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <List disablePadding>
              {content?.list.map((_content, index) => (
                <ListItem disablePadding key={`item-${index}`}>
                  <Box
                    bgcolor="background.paper"
                    borderRadius={2}
                    p={2}
                    width="100%"
                    mb={3}
                  >
                    <Box display="flex" alignItems="center" gap={2}>
                      <Image
                        alt={_content?.title}
                        height={40}
                        loader={({ src, width }) => `${src}?w=${width}`}
                        src={IconImage[_content?.icon]}
                        width={40}
                      />

                      <Typography variant="subtitle1" fontWeight={700}>
                        {_content?.title}
                      </Typography>
                    </Box>

                    <Typography variant="body1">{_content?.text}</Typography>
                  </Box>
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
      </CustomContainer>
    </Box>
  );
}
